<template>
  <div class="order-page" v-if="hasBindData.isExistShop">
    <el-card>
      <el-tabs @tab-click="handleTabClick" v-model="activeTab">
        <el-tab-pane :label="$t('stores::order::all')" :name="tabMode.all"></el-tab-pane>
        <el-tab-pane :label="$t('stores::order::wait')" :name="tabMode.toBeShipped"></el-tab-pane>
        <el-tab-pane :label="$t('stores::order::shipping')" :name="tabMode.shipped"></el-tab-pane>
        <!-- <el-tab-pane :label="$t('stores::order::error')" :name="tabMode.error"></el-tab-pane> -->
      </el-tabs>
      <z-search
        :watchValue="activeTab"
        :configs="searchConfigs"
        @do-query="query"
        @init="handleSearch"
        ref="search"
        v-model="searchForm"
      ></z-search>
    </el-card>
    <el-card style="margin-top: 10px">
      <el-row class="mb-16">
        <el-col style="text-align: right">
          <el-button
            :loading="exportLoading"
            @click="exportOrders"
            style="margin-left: 10px"
            v-auth="'stores::order::export'"
          >
            {{ $t('stores::order::export') }}
          </el-button>
        </el-col>
      </el-row>
      <z-table
        :columns="columns"
        :data="orderList"
        :max-height="480"
        :pagination.sync="pagination"
        @cell-mouse-enter="hoverShow"
        @cell-mouse-leave="hideShow"
        @page-change="handlePageChange"
        ref="table"
        v-loading="loading"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <template #orderNo="{ row }">
          <p>
            <span class="item-orderNo">{{ row.orderNo }}</span>
            <el-tooltip :content="editText.copy_order" class="item" effect="dark" placement="top">
              <i @click.stop="() => handleCopy(row.orderNo)" class="iconfont iconcopy"></i>
            </el-tooltip>
            <span style="color: red" v-if="row.riskStatus">{{ editText.risk_order }}</span>
          </p>
        </template>
        <template #sourceNo="{ row }">{{ $dataCheck(row.sourceNo) }}</template>
        <template #consigneeName="{ row }">
          <p class="consignee-name">{{ row.firstName || '-' }} {{ row.lastName || '-' }}</p>
        </template>
        <template #payTotalAmount="{ row }">{{ $dataCheck(row.payTotalAmount.toFixed(2)) }}</template>
        <template #quantity="{ row }">
          <div @click.stop style="position: relative">
            {{ row.quantity }}
            <OrderGoods :activeRow="activeRow" :row="row"></OrderGoods>
          </div>
        </template>
        <template #title="{ row }">{{ $dataCheck(row.title) }}</template>
        <template #mallType="{ row }">{{ $dataCheck(PLATFORM[row.mallType]) }}</template>
        <template #shopName="{ row }">{{ $dataCheck(row.shopName) }}</template>
        <template #payStatus="{ row }">{{ $dataCheck(PAY_STATUS[row.payStatus]) }}</template>
        <template #fulfillmentStatus="{ row }">
          {{ row.fulfillmentStatus ? $dataCheck(FULFILMENTSTATUS[row.fulfillmentStatus]) : '--' }}
        </template>
        <template #salesStatus="{ row }">{{ $dataCheck(SALES_STATUS[row.salesStatus]) }}</template>
        <template #payType="{ row }">
          <p v-if="row.payType">{{ $dataCheck(PAY_TYPE[row.payType]) }}</p>
          <p v-else>{{ row.gateway }}</p>
        </template>
        <template #createTime="{ row }">
          <p>{{ $dataCheck(row.createTime) }}</p>
        </template>
        <template #payTime="{ row }">
          <p>{{ $dataCheck(row.payTime) }}</p>
        </template>
        <template #refundStatusCode="{ row }">{{ row.shipmentStatus ? row.shipmentStatus : '-' }}</template>
        <template #bindShop="{ row }">{{ row.shopName }}</template>
        <template #operation="{ row }">
          <el-button @click.stop="handleDetail(row)" class="shipment-btn" type="text" v-auth="'stores::order::detail'">
            {{ editText.detail }}
          </el-button>
          <!-- <el-button
            @click.stop="handleSend(row)"
            class="shipment-btn"
            type="text"
            v-auth="'stores::order::ship'"
            v-if="
              (row.orderItems || []).some(item => item.fulfillmentStatus === 1 || item.fulfillmentStatus === 2) &&
                [1].some(i => i === row.payStatus)
            "
          >
            {{ editText.deliver }}
          </el-button> -->
          <!-- v-if="[1].some(i => i === row.payStatus) && [0].some(i => i === row.salesStatus)" -->
          <!-- <el-button
            @click.stop="handleAfterSale(row)"
            class="shipment-btn"
            type="text"
            v-auth="'stores::order::after'"
            v-if="[1, 4, 5, 7].some(i => i === row.payStatus)"
          >
            {{ editText.to_after_sales }}
          </el-button>
          <el-button
            @click.stop="handleCancel(row)"
            class="shipment-btn"
            type="text"
            v-auth="'stores::order::cancel'"
            v-if="row.payStatus === 0"
          >
            {{ editText.cancel_order }}
          </el-button> -->
        </template>
      </z-table>
    </el-card>
    <!-- 取消弹窗 -->
    <el-dialog :title="$t('stores::order::message_cancel')" :visible.sync="isCancelModalShow" width="40%">
      <p style="margin-bottom: 10px">{{ $t('stores::order::platform_order') }}：{{ cancelModalData.orderNo }}</p>
      <p style="margin-bottom: 10px">{{ $t('stores::order::store_order') }}：{{ cancelModalData.sourceNo }}</p>
      <p>{{ $t('stores::order::message_cancel_tips') }}</p>
      <span class="dialog-footer" slot="footer">
        <el-button @click="isCancelModalShow = false">{{ $t('system::common::btn::cancel') }}</el-button>
        <el-button @click="submitConfirmCancel" type="primary">{{ $t('system::common::btn::confirm') }}</el-button>
      </span>
    </el-dialog>
    <!-- 发货弹窗 -->
    <shipDialog :orderDetail="isSendModalData" @getDetail="getList([], false)" v-model="isSendModalShow"></shipDialog>
  </div>
  <div v-else>
    <emptyCard
      :data="{
        title: $t('stores::order::empty_title'),
        img: require('@/assets/images/emptyDefault/order@2x.png'),
        desc: $t('stores::order::empty_text'),
        buttons: [{ click: onBindShop, text: $t('stores::order::empty_button'), auth: 'stores::store::add' }],
      }"
    ></emptyCard>
  </div>
</template>
<script>
import { queryType, tabMode, queryTimeType, orderListColumns, searchConfigs } from '../config/index'
import {
  getOrderList,
  getShopList,
  getCancelOrder,
  getOrderSendMessage,
  getSendDeliver,
  putSend,
  orderReportDownload,
} from '@/server/order'
import { _local, setSession } from '@/utils/storage'
import { downloadBlobFile } from '@/utils'
import shipDialog from '@/views/order/components/shipDialog'
import OrderGoods from '@/views/order/components/orderGoods'
import moment from 'moment'
import {
  ORDER_STATUS,
  SALES_STATUS,
  FULFILMENTSTATUS,
  PAY_TYPE,
  PAY_STATUS,
  PLATFORM,
  ORDER_STATUS_LIST,
} from '@/config'
const operationCol = {
  prop: 'operation',
  label: '操作',
}

export default {
  name: 'OrderList',
  components: { shipDialog, OrderGoods },
  data() {
    return {
      ORDER_STATUS,
      SALES_STATUS,
      FULFILMENTSTATUS,
      PAY_TYPE,
      PLATFORM,
      PAY_STATUS,
      queryType,
      queryTimeType,
      tabMode,
      activeTab: tabMode.all,
      orderList: [],
      exportLoading: false,
      columns: orderListColumns,
      pagination: {
        pageNum: 1, // 页码
        pageSize: 10, // 每页大小
        total: 0,
      },
      loading: false,
      operationCol,
      // 订单状态
      orderStatusList: ORDER_STATUS_LIST,
      searchForm: {
        fulfilmentStatus: '',
        searchShop: '',
        searchDate: '',
        filterObj: 'order_no',
      },
      shopList: [], // 可搜索的店铺列表
      isCancelModalShow: false,
      cancelModalData: {
        orderNo: '',
        sourceNo: '',
      },
      isSendModalShow: false,
      isSendModalData: {},
      sendLoading: false,
      sendDataList: [],
      selectedNumber: 0,
      sendModalForm: {
        type: '',
        number: '',
        link: '',
        time: '',
      },
      // 物流类型选项
      sendOptions: [],
      hasConfirmed: false, // 发货提示是否显示
      activeRow: '',
      editText: {
        copy_order: this.$t('stores::order::copy_order'),
        risk_order: this.$t('stores::order::risk_order'),
        deliver: this.$t('stores::order::deliver'),
        detail: this.$t('stores::order::detail'),
        to_after_sales: this.$t('stores::order::to_after_sales'),
        cancel_order: this.$t('stores::order::cancel_order'),
      },
    }
  },
  computed: {
    queryTypeHolder() {
      return this.queryType.find(item => item.value === this.curQueryType).placeholder
    },
    searchConfigs() {
      let newSearchConfigs = [...searchConfigs]
      if (this.activeTab !== 'all')
        newSearchConfigs = newSearchConfigs.filter(i => i.key !== 'salesStatus' && i.key !== 'fulfilmentStatus')
      return newSearchConfigs
    },
  },
  async mounted() {
    this.getShopData()
    this.getList([], true)
    // 获取物流商信息
    this.getFulfillment()
  },
  methods: {
    async exportOrders() {
      this.exportLoading = true
      let params = this.$refs.search.getSearchParams()
      const res = await orderReportDownload({
        ...params,
        ...this.getParams(),
      })
      this.exportLoading = false
      if (res.code === this.$code) {
        downloadBlobFile(
          '\uFEFF' + res.response.data,
          {
            type: 'application/csv;charset=UTF-8',
          },
          `orders_${moment().format('YYYYMMDD')}.csv`
        )
      }
    },
    onBindShop() {
      this.$store.commit('setShopVisiable', { visiable: true })
    },
    async getShopData() {
      var obj = {
        pageSize: 10,
        pageNum: 1,
      }
      const { data } = await getShopList(obj)
      this.shopList = data.data
    },
    handleTabClick(ele) {
      this.searchForm.shop_ids = []
      this.getList([], true)
    },
    getParams() {
      const data = {
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        order_no: this.searchForm.filterObj === 'order_no' ? this.searchForm.target : '',
        source_no: this.searchForm.filterObj === 'source_no' ? this.searchForm.target : '',
        customer: this.searchForm.filterObj === 'customer' ? this.searchForm.target : '',
        fulfilment_status: this.searchForm.fulfilmentStatus ? [String(this.searchForm.fulfilmentStatus)] : [],
        shop_ids: this.searchForm.shopId ? [String(this.searchForm.shopId)] : [],
        pay_time_start: this.searchForm.createTime || '',
        pay_time_end: this.searchForm.endTime || '',
        orderCreateTimeEnd: this.searchForm.orderCreateTimeEnd,
        orderCreateTimeStart: this.searchForm.orderCreateTimeStart,
        mall_type: this.searchForm.mallType || null,
        sales_status: this.searchForm.salesStatus ? [String(this.searchForm.salesStatus)] : [],
        amount_start: this.searchForm.minNumber || null,
        amount_end: this.searchForm.maxNumber || null,
      }
      if (this.activeTab !== 'all') {
        // data['sales_status'] = []
        if (this.activeTab === 'SHIPPED') {
          data['fulfilment_status'] = ['2', '3']
          data['sales_status'] = []
        } else if (this.activeTab === 'TO_BE_SHIPPED') {
          data['fulfilment_status'] = ['1', '2']
          data['sales_status'] = []
        } else if (this.activeTab === 'error') {
          data['sales_status'] = ['1', '2', '3', '4']
        }
      }
      return data
    },
    refresh() {
      const searchData = this.$refs[this.activeTab].getSearchParams()
      this.getList(searchData, false)
    },
    async getList(searchParams, init = false) {
      if (init) {
        // 回到第一页
        this.pagination.pageNum = 1
      }

      this.loading = true
      const params = this.getParams()
      const { data } = await getOrderList({ ...searchParams, ...params })
      if (data.code === this.$code) {
        this.orderList = data.data.items
        this.pagination.total = data.data.totalCount ? data.data.totalCount : 0
      }
      this.loading = false
    },
    handlePageChange() {
      this.getList([], false)
    },
    handleCopy(orderNo) {
      const _this = this
      this.$copyText(orderNo).then(
        function (e) {
          _this.$message.success(_this.$t('system::tip::copy_success'))
        },
        function (e) {}
      )
    },
    handleExportSearchParams() {
      const data = { orderStatus: this.activeTab === 'all' ? [] : [this.activeTab] }
      const searchData = this.$refs[this.activeTab].getSearchParams()
      return { ...data, ...searchData }
    },
    query(params) {
      console.log(params)
      this.searchForm = params
      this.getList(params, false)
    },
    handleSearch(value) {
      this.searchForm = {
        ...this.searchForm,
        ...value,
      }
      this.getList([], false)
    },
    // handleReset() {
    //   this.fulfilmentStatus = []
    //   this.searchShop = ''
    //   this.searchDate = ''
    //   this.getList([], true)
    // },
    handleDetail(row) {
      _local.set(
        'orderNumberList',
        this.orderList.map(item => item.orderNo)
      )
      setSession('backUrl', '/order')
      const searchParams = { ...this.getParams() }
      // this.$store.commit('order.query', {
      //   params: searchParams,
      //   query: async (page, searchParams, callback) => {
      //     if (page) {
      //       // 回到第一页
      //       searchParams.pageNum = page
      //     }
      //     const { data } = await getOrderList({ ...searchParams })
      //     if (data.code === this.$code) {
      //       if (callback) callback(data.data.items)
      //     }
      //   }
      // })
      this.$router.push(`orderDetail/${row.orderNo}`)
    },
    handleSend(row) {
      if (
        row.orderItems
          .filter(item => item.fulfillmentStatus === 1 || item.fulfillmentStatus === 2)
          .every(item => item.salesStatus > 0)
      ) {
        return this.$message.warning(this.$t('stores::order::message_deliver'))
      }
      this.isSendModalData = row
      this.isSendModalShow = true
    },
    async getFulfillment() {
      var obj = {
        dictCode: 'shipping_company',
      }
      const { data } = await getSendDeliver(obj)
      if (data.code === 0) {
        this.sendOptions = data.data
      }
    },
    handleCancel(row) {
      this.isCancelModalShow = true
      this.cancelModalData = {
        ...row,
      }
    },
    async submitConfirmCancel() {
      var obj = {
        order_no: this.cancelModalData.orderNo,
      }
      const { data } = await getCancelOrder(obj)
      if (data.code === 0) {
        this.$message.success(this.$t('system::tip::cancel_success'))
        this.getList([], false)
        this.isCancelModalShow = false
      }
    },
    sendSelectChange(value) {
      this.sendDataList = value
      this.selectedNumber = value.length
    },
    handleAfterSale(row) {
      this.$router.push(`add-after-order/${row.orderNo}`)
    },
    hoverShow(row) {
      this.activeRow = row.orderNo
    },
    hideShow() {
      this.activeRow = ''
    },
  },
}
</script>
<style lang="scss" scoped>
.item-orderNo {
  display: inline-block;
  width: 160px;
}
i.iconcopy {
  cursor: pointer;
}
.shipment-btn {
  cursor: pointer;
  &:hover {
    color: $--color-primary;
  }
}
p.consignee-name {
  display: inline-block;
  word-break: break-word;
}
.search {
  display: flex;
  // padding-bottom: 20px;
  flex-wrap: wrap;
  // align-items: center;
  .line {
    margin-right: 20px;
    margin-bottom: 20px;
  }
}

.sendModal {
  .title {
    font-size: 18px;
    margin-left: 20px;
    // margin-top: 10px;
  }
  .message {
    .line {
      display: flex;
      // justify-content: center;
      margin-top: 20px;
      padding: 0px 30px 0px 30px;
      span {
        label {
          width: 50px;
        }
      }
    }
  }
  .sendTips {
    color: red;
    margin: 10px 0px;
    padding-left: 30px;
  }
  .detail {
    padding-left: 30px;
    .number {
      color: orange;
    }
  }
  .good {
    padding-left: 30px;
    margin-top: 10px;
  }
}
</style>
